import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllPosts } from '../../../redux/thunk/thunk';
import { dictionary } from '../../../dictionary';
import { Card } from 'primereact/card';

const TotalHourCounter = () => {
  const dispatch = useDispatch();
  const allPosts = useSelector((state) => state.allPosts?.data);

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const startYear = currentMonth < 2 ? currentYear - 1 : currentYear;
  const endYear = startYear + 1;
  const period = `March ${startYear} - February ${endYear}`;

  useEffect(() => {
    dispatch(fetchAllPosts());
  }, [dispatch]);

  const { totalHours, totalEsp } = useMemo(() => {
    if (!allPosts || !Array.isArray(allPosts)) {
      return { totalHours: 0, totalEsp: 0 };
    }

    const startDate = new Date(startYear, 2, 1);
    const endDate = new Date(endYear, 2, 1);

    let hoursSum = 0;
    let espSum = 0;

    allPosts.forEach((post) => {
      const postDate = new Date(post.date);

      if (postDate >= startDate && postDate < endDate) {
        hoursSum += Number(post.hours) || 0;

        if (post.esp && post.esp !== '') {
          espSum += Number(post.hours) || 0;
        }
      }
    });

    return { totalHours: hoursSum, totalEsp: espSum };
  }, [allPosts, startYear, endYear]);

  const eldHeader = <div className="eld-card" />;
  const espHeader = <div className="esp-card" />;

  const totalEld = totalHours - totalEsp;

  return (
    <div className="admin-hours-wrapper ">
      <h3 className="fiscal-title">
        {dictionary.admin_hours_fiscal_title} {period}
      </h3>

      <div className="card-wrapper">
        <Card header={eldHeader}>
          <div className="card-content-wrapper">
            <i className="pi pi-clock"></i>
            <div>
              <span>
                <h1>{totalEld.toLocaleString()}</h1>
                <h2>h</h2>
              </span>
              <span>{dictionary.admin_hours_eld}</span>
            </div>
          </div>
        </Card>
        <Card header={espHeader}>
          <div className="card-content-wrapper">
            <i className="pi pi-chart-line esp-icon"></i>
            <div>
              <span>
                <h1>{totalEsp.toLocaleString()}</h1>
                <h2 className='h2-esp'>h</h2>
              </span>
              <span>{dictionary.admin_hours_esp}</span>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default TotalHourCounter;
